var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm text-center"
  }, [_c('b-card-body', {
    staticClass: "p-6"
  }, [_c('b-card-title', {
    staticClass: "mb-6"
  }, [_vm._v("Meta de Faturamento")]), _vm.loading ? [_c('ul', {
    staticClass: "list-unstyled m-0 p-0"
  }, _vm._l(3, function (i) {
    return _c('li', {
      key: i,
      staticClass: "d-flex align-items-center mb-6"
    }, [_c('div', {
      staticClass: "d-flex justify-content-center align-items-center rounded-circle mr-4",
      staticStyle: {
        "width": "36px",
        "height": "36px",
        "background-color": "#f3f6f9"
      }
    }, [_c('b-skeleton', {
      attrs: {
        "width": "18px",
        "height": "18px"
      }
    })], 1), _c('div', {
      staticClass: "flex-grow-1",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('b-skeleton', {
      attrs: {
        "width": "40%",
        "height": "16px"
      }
    }), _c('b-skeleton', {
      attrs: {
        "width": "20%",
        "height": "14px"
      }
    })], 1), _c('b-skeleton', {
      staticClass: "mt-2",
      attrs: {
        "height": "8px"
      }
    })], 1)]);
  }), 0)] : [_c('div', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "position-relative mr-6"
  }, [_c('svg', {
    attrs: {
      "width": _vm.size,
      "height": _vm.size
    }
  }, [_c('circle', {
    staticClass: "circle-bg",
    attrs: {
      "r": _vm.raio,
      "cx": _vm.center,
      "cy": _vm.center,
      "fill": "none"
    }
  }), _c('circle', {
    staticClass: "circle-progress",
    attrs: {
      "r": _vm.raio,
      "cx": _vm.center,
      "cy": _vm.center,
      "fill": "none",
      "stroke-dasharray": _vm.circunferencia,
      "stroke-dashoffset": _vm.dashOffset
    }
  })]), _c('div', {
    staticClass: "position-absolute",
    style: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }, [_c('span', {
    staticClass: "h4 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.displayPercent))])])]), _c('div', [_c('div', {
    staticClass: "mb-2"
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Meta")]), _c('span', {
    staticClass: "h6"
  }, [_vm._v(_vm._s(_vm.toCurrency(_vm.metaValue)))])]), _c('div', [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Atingido")]), _c('span', {
    class: {
      'text-success': _vm.percentNumber >= 100,
      'text-warning': _vm.percentNumber < 100
    }
  }, [_vm._v(" " + _vm._s(_vm.toCurrency(_vm.atingidoValue)) + " ")])]), _c('div', {
    staticClass: "mt-3"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.percentNumber >= 100 ? 'badge-success' : 'badge-primary'
  }, [_vm._v(" " + _vm._s(_vm.percentNumber >= 100 ? "Meta Alcançada" : "Em Progresso") + " ")])])])])]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };